import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
   providedIn: 'root'
})
export class ReferrerService {
   private readonly tabCounterKey = 'openTabs';
   private readonly popupShownKey = 'externalReferrerPopupShown';
   private externalReferrer = false;
   private isBrowser = false;

   constructor(@Inject(PLATFORM_ID) private platformId: Object) {
      this.isBrowser = isPlatformBrowser(this.platformId);
      if(this.isBrowser) {
         const myDomain = window.location.hostname;
         const referrer = document.referrer;
         // const excludedDomain = environment.excludedReferrer;
         const excludedDomain = 'https://localhost:4200/'

         // Determine if the user came from an external site, excluding 'excludedDomain'
         if (!referrer || (!referrer.includes(myDomain) && !referrer.includes(excludedDomain))) {
            this.externalReferrer = true;
         }

         // Increment the number of open tabs
         let tabs = parseInt(localStorage.getItem(this.tabCounterKey) || '0', 10);
         tabs += 1;
         localStorage.setItem(this.tabCounterKey, tabs.toString());

         // Decrement tab count when tab closes
         window.addEventListener('beforeunload', () => {
            let tabs = parseInt(localStorage.getItem(this.tabCounterKey) || '1', 10);
            tabs = Math.max(tabs - 1, 0);
            localStorage.setItem(this.tabCounterKey, tabs.toString());

            // If all tabs are closed, reset popup shown
            if (tabs === 0) {
               localStorage.removeItem(this.popupShownKey);
            }
         });
      }
   }

   cameFromExternal(): boolean {
      return this.externalReferrer;
   }

   popupAlreadyShown(): boolean {
      if(this.isBrowser) {
         return localStorage.getItem(this.popupShownKey) === 'true';
      }
      return false;
   }

   markPopupShown(): void {
      if(this.isBrowser) {
         localStorage.setItem(this.popupShownKey, 'true');
      }
   }

   isFirstTab(): boolean {
      if(this.isBrowser) {
         const tabs = parseInt(localStorage.getItem(this.tabCounterKey) || '0', 10);
         return tabs === 1;
      }
      return false;
   }
}